<template>
  <div id="app">
    <router-view v-show="initialized" />
  </div>
</template>

<script>
export default {
  name: 'app',
  watch: {
    performLogout (newValue) {
      if (newValue) {
        this.$router.push('/login')
      }
    }
  },
  computed: {
    initialized () {
      return this.$store.getters.initialized
    },
    performLogout () {
      return this.initialized && this.$store.getters.forceLogout
    }
  }
}
</script>

<style>
html,
body {
  margin: 0;
  background: white;
  /* Try avoid bounce overflow scroll in Safari */
  position: fixed;
  overflow: hidden;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  text-align: center;
  margin-top: 40px;
}

header {
  margin: 0;
  height: 56px;
  padding: 0 16px 0 24px;
  background-color: #35495E;
  color: #ffffff;
}

header span {
  display: block;
  position: relative;
  font-size: 20px;
  line-height: 1;
  letter-spacing: .02em;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue